import {
  ADD_NEW_ASSISTANT,
  UPDATE_ASSISTANT,
  DELETE_ASSISTANT,
  START_LOADING,
  END_LOADING,
  FETCH_ASSISTANTS_BY_USER,
} from "../actions/constants";

const assistants = (state = { isLoading: true, assistants: [] }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };

    case FETCH_ASSISTANTS_BY_USER:
      return { ...state, assistants: action.payload };

    case ADD_NEW_ASSISTANT:
      return { ...state, assistants: [...state.assistants, action.payload] };
    case UPDATE_ASSISTANT:
      return {
        ...state,
        assistants: state.assistants.map((assistant) =>
          assistant._id === action.payload._id ? action.payload : assistant
        ),
      };
    case DELETE_ASSISTANT:
      return {
        ...state,
        assistants: state.assistants.filter((e) => e._id !== action.payload),
      };
    default:
      return state;
  }
};

export default assistants;
